export enum GridGap {
    GAP0 = 0,
    GAP1 = 1,
    GAP2 = 2,
    GAP3 = 3,
    GAP4 = 4,
    GAP5 = 5
}
